import { Button } from 'antd'
import { t } from 'i18next'
import { useState } from 'react'
import {
  ModalBase,
  ModalContentContainer,
  ModalTextDescription,
  ModalTextLabel,
} from '../../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../../constants/constants'
import { AlgorithmRunDelConfig } from '../../../../../store/reducers/workspaceReducer'
import SmartFunctionActionDropdownDropDownItem from '../../../components/SmartFunctionActionDropdown/SmartFunctionActionDropdownDropDownItem'
interface DelLastConfigurationModalProps {
  config?: AlgorithmRunDelConfig
}

const DelLastConfigurationModal = ({
  config,
}: DelLastConfigurationModalProps) => {
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const documentName = config?.documentName || NO_DATA_PLACEHOLDER

  return (
    <>
      <SmartFunctionActionDropdownDropDownItem
        onClick={() => {
          setOpen(true)
        }}
      >
        {t(
          'workspaceDetailsPage.workspaceSmartFunctionPanel.actionMenu.viewRunSetup'
        )}
      </SmartFunctionActionDropdownDropDownItem>
      <ModalBase
        destroyOnClose
        key="delLastConfigModal"
        title={t('delConfigurationModal.modalTitle')}
        open={open}
        onOk={handleClose}
        onCancel={handleClose}
        forceRender
        footer={<Button onClick={handleClose}>{t('Close')}</Button>}
      >
        <ModalContentContainer>
          <ModalTextLabel>
            {t('delConfigurationModal.steps.review.inputHeader')}
          </ModalTextLabel>
          <ModalTextDescription>{documentName}</ModalTextDescription>
        </ModalContentContainer>
      </ModalBase>
    </>
  )
}

export default DelLastConfigurationModal
